import { render, staticRenderFns } from "./worth_four_dot.config.vue?vue&type=template&id=58f16304"
import script from "./worth_four_dot.config.vue?vue&type=script&lang=js"
export * from "./worth_four_dot.config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports